import SideNav from './SideNav';
import Aran from './Aran';
import './DashboardLayout.css';

export default function DashboardLayout({ children, noAran = false }) {
  return (
    <div className="dl">
      <SideNav />
      <main className="dl__main">{children}</main>
      {!noAran && <Aran />}
    </div>
  );
}
